import type { CCrmProjectManagementTranslations } from "./pl";

export const en: CCrmProjectManagementTranslations = {
  emptyData: "No data to display.",
  emptyOffer: "We currently have no packages available to order online.",
  netto: "net",
  brutto: "gross",
  oneTime: "one-off",
  recommended: "Recommended",
  priority: "Priority support",
  formatTrial: (days) => `Try free for ${days} days`,
  formatPeriod: (period) => `/ ${period}`,

  orderCta: "Order",
  orderBack: "Back to the offer",
  orderLoading: "Loading the order form...",
  orderLoadFailed: "The order form could not be loaded.",
  orderSummaryPrice: "Amount due",
  orderNoAccountTypes:
    "Online ordering is not configured yet - contact us and we will place the order for you.",
  orderHaveAccount: "I already have an account - sign in",
  orderLoginHide: "I will fill in my details without signing in",
  orderLoginField: "Login or e-mail address",
  orderPasswordField: "Password",
  orderLoginSubmit: "Sign in",
  orderLoginFailed: "Signing in failed.",
  orderLoginMfa:
    "Your account requires an additional sign-in confirmation. Sign in on the account page and come back to the order.",
  orderLoggedDataNote:
    "We took these details from your account. Correct them if the invoice needs different ones - we will save them with the order.",
  orderAccountTypeLegend: "I am ordering as",
  orderAccountCompany: "Company",
  orderAccountPrivate: "Private person",
  orderSectionContact: "Contact details",
  orderSectionCompany: "Company details",
  orderSectionCompanyHint: "These details will appear on the invoice for the service.",
  orderSectionBilling: "Billing details",
  orderProjectLegend: "Project",
  orderProjectNew: "- new project -",
  orderProjectHint:
    "The service will be attached to the selected project. Choose a new project if this is a separate engagement.",
  orderTrialHint:
    "The trial starts the service right away, with no payment and no invoice. Once it ends the service can be renewed.",
  orderGusFetch: "Fetch the company details from the register by VAT ID",
  orderGusBusy: "Fetching from the register...",
  orderGusFilled: "Company details filled in from the REGON register. Check them before sending.",
  orderGusNotFound: "We found no company with this VAT ID in the REGON register.",
  orderGusNipRequired: "Enter a VAT ID to fetch the details from the register.",
  orderSelectEmpty: "- select -",
  orderDictionaryLoading: "Loading the list...",
  orderDictionaryFailed: "The list of options could not be loaded.",
  orderRegulaminLegend: "Terms and conditions",
  orderRegulaminAccept: "I accept the terms of the service",
  orderRegulaminShow: "Show the terms",
  orderRegulaminHide: "Hide the terms",
  orderRegulaminRequired: "The order requires accepting the terms.",
  orderFieldRequired: "This field is required.",
  orderFieldInvalidUrl: "Enter a valid website address, e.g. https://yourcompany.com",
  orderFieldExample: "For example:",
  orderFieldInvalidDate: "Enter a date in the YYYY-MM-DD format.",
  orderFieldInvalidNumber: "Enter a number.",
  orderFieldInvalidDigit: "Enter a whole number, with no decimal part.",
  orderFieldBelowMin: "The value cannot be lower than {min}.",
  orderFieldMinHint: "Minimum value: {min}.",
  orderEmailRequired: "Enter an e-mail address - we will send the client panel access there.",
  orderSubmitPaid: "Order and go to payment",
  orderSubmitFree: "Order",
  orderSubmitTrial: "Start the free trial",
  orderPaymentLink: "Go to payment",
  orderPasswordEmail:
    "We created an account for you. We sent a link to set your password to the address you gave - once it is set you can sign in to the client panel.",
  formatOrderTitle: (name) => `Order: ${name}`,
  formatOrderLoggedAs: (name) => `You are ordering as ${name}.`,
  formatOrderTrialHeading: (days) => `You can try it free for ${days} days`,
  formatOrderTrialSummary: (days) => `Free trial: ${days} days, no payment.`,
};
